// 导出 src/router/menusRoutes 文件夹下的所有 *.js 文件路由
const modules = require.context("@/router/menusRoutes", false, /\.js$/);
const routes = [];
modules.keys().forEach((key) => {
  routes.push(...modules(key).default);
});
// console.log('menu routers =>', [...routes]);

export default routes;
